import { isValidToken } from '../shared/api.js';

/**
 * V02(単体ページ)のトークン取得。
 *
 * **V01 との差分はここだけ**([#33](../../../../docs/issues/33-viewer-embed/DESIGN.md)
 * の「V01 と V02 の差分」)。V01 は `data-signa-preview` 属性、V02 は URL。
 *
 * 対応する形:
 * - `/v/pv_xxx`(配信時のパス)
 * - `/?token=pv_xxx`(開発サーバ・共有 URL)
 */
export function tokenFromLocation(location: {
  readonly pathname: string;
  readonly search: string;
}): string | null {
  const fromQuery = new URLSearchParams(location.search).get('token');
  if (isValidToken(fromQuery)) return fromQuery;

  // パスの最後のセグメントを見る。`/v/pv_xxx` にも `/pv_xxx` にも対応する。
  const segments = location.pathname.split('/').filter((s) => s !== '');
  const last = segments[segments.length - 1];
  return isValidToken(last) ? last : null;
}
